import { render, staticRenderFns } from "./pagintion.vue?vue&type=template&id=76045e24&scoped=true&"
import script from "./pagintion.vue?vue&type=script&lang=js&"
export * from "./pagintion.vue?vue&type=script&lang=js&"
import style0 from "./pagintion.vue?vue&type=style&index=0&id=76045e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76045e24",
  null
  
)

export default component.exports